// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PEuroOutlinedSvg from "@fishx/icons-svg/es/asn/PEuroOutlined";
import FishxIcon from '../components/FishxIcon';

var PEuroOutlined = function PEuroOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PEuroOutlinedSvg
  }));
};

PEuroOutlined.displayName = 'PEuroOutlined';
export default React.forwardRef(PEuroOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PEuroOutlined.js
// module id = 3364
// module chunks = 0